import { render } from "./HomeComponents.vue?vue&type=template&id=f8ffefc0"
import script from "./HomeComponents.vue?vue&type=script&lang=js"
export * from "./HomeComponents.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__